module.exports = __webpack_public_path__ + "static/media/OFmidterm_img.a0e2ba91.jpg";